const DigestionSVG = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 128 128">
      <path
        d="M20 50c0-20 30-20 30 0s30 20 30 0 30-20 30 0"
        fill="none"
        stroke="#063"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default DigestionSVG;
